import { Box, Collapse, Divider, Stack } from "@mui/material";
import React from "react";
import { AddOnItem } from "./AddOnItem";
import { useEventCardCtx } from "./EventCard";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { groupAddOnsBySubCategory } from "./utils.homepageFlow";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

export function EventCardAddOns() {
  const { HOME_PAGE_SETTINGS } = useTeamConfig();
  const { md: mdUp } = useCssMediaQuery("up");
  const eventCardCtx = useEventCardCtx();
  const addOnsGrouped =
    HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "grouped"
      ? groupAddOnsBySubCategory(eventCardCtx.addOns)
      : [];

  const openAddOnsByDefault =
    HOME_PAGE_SETTINGS?.ADD_ON?.OPEN_ADD_ONS_BY_DEFAULT || false;

  return (
    <Collapse in={eventCardCtx.isAddOnsOpen || openAddOnsByDefault}>
      {eventCardCtx?.addOns?.length ? (
        <Divider
          sx={{
            backgroundColor: eventCardCtx.colors.borderColor,
            borderColor: "transparent",
          }}
        />
      ) : null}

      {HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "grouped" ? (
        <Stack spacing={2} p={mdUp ? 3 : 1.5}>
          {addOnsGrouped?.map((group, idx) => {
            return (
              <Box
                key={idx}
                border={`1px solid ${eventCardCtx.colors.borderColor}`}
                borderRadius={2}
                position={"relative"}
              >
                {group.map((addOn, idx) => {
                  return (
                    <Box key={addOn.productId}>
                      {idx !== 0 ? (
                        <Divider
                          sx={{
                            backgroundColor: eventCardCtx.colors.borderColor,
                            borderColor: "transparent",
                          }}
                        />
                      ) : null}

                      <Box p={mdUp ? 3 : 2}>
                        <AddOnItem
                          key={addOn.productId}
                          addOn={addOn}
                          isDarkBg={eventCardCtx.isDarkBg}
                          isDisabled={Boolean(addOn?.isOptInRequired) && !Boolean(eventCardCtx?.event?.optedIn)}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            );
          })}
        </Stack>
      ) : null}

      {HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "list" ||
      !HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE ? (
        <Box px={mdUp ? 3 : 1.5}>
          {eventCardCtx.addOns?.map((addOn, idx) => {
            return (
              <React.Fragment key={addOn.productId}>
                {idx !== 0 ? (
                  <Divider
                    sx={{
                      backgroundColor: eventCardCtx.colors.borderColor,
                      borderColor: "transparent",
                    }}
                  />
                ) : null}

                <Box py={mdUp ? 3 : 2}>
                  <AddOnItem
                    key={addOn.productId}
                    addOn={addOn}
                    isDarkBg={eventCardCtx.isDarkBg}
                    isDisabled={Boolean(addOn?.isOptInRequired) && !Boolean(eventCardCtx?.event?.optedIn) }
                  />
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      ) : null}
    </Collapse>
  );
}
